import { remove } from '@/api/domains.api'
import useAPI from '../useAPI'

export default (params = {}) => useAPI({
  request: remove,
  params
})
